<template lang="pug">
  layout(v-if="document.id" @scrollContent="onContentScroll")

    //- Statusbar
    //- template(v-slot:statusbar)
      .navbar
        .navbar-start
          .navbar-item
            b-switch(v-model="showSidebar") Слайды
        .navbar-center
          .navbar-item
            .field.has-addons.has-addons-centered(v-if="progress==100")
              .control
                b-button.is-primary(icon-left="check") Я изучил(а) материал
            .field(v-else): .control.mt-10(style="width:350px")
              b-progress(type="is-dark" :value="progress" show-value) {{ progress }}%

        .navbar-end
          .navbar-item
            b-button(icon-left="download") Загрузить

    //- Sidebar
    //- template(v-slot:sidebar v-if="showSidebar")
      .slides
        .slides-thumbnail(v-for="slide in presentation.slides" :key="slide.id")
          img(:src="slide.thumbnail")

    //- Content
    template(v-slot:content)
      .section: .container.content

        .container.content
          .field.has-addons.is-pulled-right(v-if="document.allow_download && document.file")
            .control
              b-button(v-if="document.file_type" tag="a" :href="document.file")
                b-icon(:type="document.file_type.style" :icon="document.file_type.icon")
                span {{ document.file_original_name }}
            .control: b-button(tag="a" :href="document.file" icon-left="download")

          h1.mt-0 {{ document.name }}
          blockquote(v-if="document.description") {{ document.description }}

          //- Type: Text
          template(v-if="document.isTypeText")
            //- .content(v-html="document.content")
            .card: .card-content
              section(ref="content" v-html="content")

          //- Type: Slides
          template(v-if="document.isTypeSlides")
            .card.mb-20(v-for="slide,index in document.content" :key="index")
              .card-image: img(:src="slide")

          //- Type: File
          template(v-if="document.isTypeFile"): .card: .card-content
            b-message(type="is-info" has-icon)
              b-button.is-pulled-right.is-primary(v-if="document.file_type" tag="a" :href="document.file")
                b-icon(icon="download")
                span Скачать файл
              div: strong Просмотр данного файла невозможен.
              div Вы можете скачать файл на компьютер чтобы посмотреть его содержимое.

        //- .field.has-addons.has-addons-centered(v-if="progress==100")
          .control
            b-button.is-primary(size="is-large" icon-left="check") Я изучил(а) материал



</template>

<script>
import Document from '@/models/Document';

export default {
  props: {
    document: Document,
  },

  data: () => ({
    showSidebar: false,
    progress: 0,

    // document: new Document(),
  }),

  computed: {
    content() {
      return this.document.content;
    },
  },

  watch: {
    content() {
      if (this.$refs.content) {
        this.$refs.content.innerHTML = this.content;
      }
      // console.log();
    },
  },

  async created() {
    // this.$route.meta.title = 'Мочекаменная болезнь';
    // this.$router.replace({ query: { temp: Date.now() } });
    // this.$router.replace({ query: { temp: undefined } });
    // await this.document.$find(2, {});
  },

  methods: {
    onContentScroll(percentage) {
      if (percentage) {
        const progress = Math.round(percentage);
        if (progress > this.progress) {
          this.progress = progress;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.slides {
  padding: 15px;
  .slide-image {
    margin-bottom: 40px;
  }
  .slides-thumbnail {
    & + .slides-thumbnail {
      margin-top: 15px;
    }
    & > img {
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      min-width: 100%;
      display: block;
    }
  }
}
</style>
